import { createStore,compose } from 'redux';
import { applyMiddleware } from 'redux';
import myReducer from './../reducers/index';
import thunk from 'redux-thunk';

//process.evn.NODE_EVN !== 'production' && 
const composeEnhancers = 
 	typeof window === 'object' &&
 	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
 		shouldHotReload: false,
 	}) 
 	: compose

const configStore = () =>{
	const middlewares = [thunk];
	const enhancers = [
		applyMiddleware(...middlewares)
	];
	const store = createStore(myReducer, composeEnhancers(...enhancers));
	return store;
};

export default configStore;